export default __webpack_public_path__ + "images/7R.8cf4879.png";